import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ConfirmModal from '../shared/confirm-modal';
import Notifications from '../utils/notification-helper';

@inject('appStore')
@observer
export default class UnlinkGoogleAccountModal extends Component {
    constructor(props) {
        super(props);
    }

    handleUnlinkAccount() {
        appStore.coordinatorDetailStore
            .unlinkGoogleCredential()
            .then(() => {
                Notifications.ToastSuccess('Successfully unlinked your Google Account.');
            })
            .catch(() => {
                Notifications.ToastError('Something went wrong when trying to unlink your Google Account.');
            })
            .finally(() => {
                appStore.viewStore.hideUnlinkGoogleAccountModal();
            });
    }

    render() {
        var coordinatorEmail = appStore.coordinatorDetailStore.coordinator.email;

        return (
            <ConfirmModal
                show={appStore.viewStore.unlinkGoogleAccountDialogOpen}
                onHide={appStore.viewStore.hideUnlinkGoogleAccountModal}
                onConfirmed={this.handleUnlinkAccount.bind(this)}
                headerText={'Unlink Google Account'}
                buttonType={'btn-primary'}
                bodyText={`Are you sure you want to unlink your Google account (${coordinatorEmail})?`}
                buttonText={'Unlink Account'}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/coordinators/unlink-google-account-modal.js